<template>
  <v-container>
    <template>
      <v-row class="mt-n15 ml-33" style="max-width: 600px; margin-left: 35pc">
        <v-col cols="3" class="pa-0 pr-1">
          <v-select
            class="input-text-size"
            label="Resale Year"
            :items="saleYearList"
            v-model="criteriaState.saleYear"
            item-text="name"
            item-value="value"
            @change="searchByCriteria" />
          </v-col>
          <v-col cols="3" class="pa-0 pr-1"></v-col>
          <v-col cols="3" class="pa-0 pr-1">
            <ClarionDateControl class="input-text-size" :isToggle="false"
            :penalty-change-day="Number(taxSettingItem.penaltyDate) || null"
            v-model="penaltyDateValue" label="Penalty Date" />
          </v-col>
          <v-col cols="3" class="pa-0 mt-4 pl-5">
            <v-btn color="primary" small rounded :class="resalePenaltyStaleBtnClass"
              @click="handleRecalculate()">Recalculate</v-btn>
            <ResalePenaltyStaleWarning :isStale="isResalePenaltyOutdated" />
          </v-col>
        </v-row>
      <CRUDList ref="crudList" :canAdd="false" :canEdit="true"
        :canSave="true" :showSelect="false" :canDeleteInDialog="true"
        :enableFixedHeaders="true" :displayTopPagination="false" :headers="headers"
        :baseCrudKey="baseCrudKey" :dialogHeaderName="dialogHeaderName"
        :defaultSortBy="defaultSortBy" dialogDynamicWidth="60vw"
        tableWrapperDynamicClassname='elevation-3 ma-3 pt-0 pa-1 taxroll-table-wrapper'
        tableDynamicClassname='taxroll-custom-table' tableDynamicHeight="400"
        @deleteItem="deleteFromDiaglog" @upsertItem="upsertItem"
        @loadCRUDList="handleLoadList" :loadingData="gridLoading.flag"
        :loadingText="gridLoading.text">
        <template v-slot:[`editedItem`]="{ }">
          <DayOfSaleDialog :baseCrudKey="baseCrudKey" @loadCRUDList="handleLoadList"
          :baseCrudKeyForBidderRegistration="baseCrudKeyForBidderRegistration"
          @createPayment="createPayment" @upsertItem="upsertItem"
          :creatingAdjustments="creatingAdjustments"
          @createAdjustments="createAdjustments" ref="dayOfSaleDialog" />
        </template>
      </CRUDList>
      <CommonPaymentDialog ref="commonPayment" :baseCrudKey="paymentCrudKey"
      :isThereMultipleItems="true" :isItFromJuneResale="true"
      :fromCompBaseCrudKey="fromCompBaseCrudKey" @upsertFuncCall="upsertFuncCall" />
    </template>
  </v-container>
</template>

<script>
import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import {
  amountFormat, amountToNumber, defaultGridLoading, manageGridLoading,
} from '../../../../../util/shared/vue-global';
import CRUDList from '../../../../common/base/crud-2.0/CRUDList.vue';
import { dayOfSaleMainHeader } from '../../deliquentUtils/deliquent.utils';
import DayOfSaleDialog from './DayOfSaleDialog.vue';
import { juneResaleCommonPostProcessTrans, makeCriteriaStateNullIfEmptyString } from '../../../common-utils/CommonTaxFunctionalities';
// import { getBusinessDateForPaymentEntry, toIsoDate } from '../../../../../util/shared/tmc-global';
// import { getWorkstationNumber } from '../../../../../util/workstation-util';
import PaymentCommonFunc from '../../../common-utils/PaymentCommonFunc.mixin';
import CommonPaymentDialog from '../../../TaxInquiry/Common/CommonPaymentDialog.vue';
import ClarionDateControl from '../../../../common/ClarionDateControl.vue';
import { toIsoDate } from '../../../../../util/shared/tmc-global';
import { resaleConfigScope } from '../../../../../util/shared/system-config-scopes';
import ResalePenaltyStaleWarning from '../ResalePenaltyStaleWarning.vue';
import resalePenaltyStaleMixin from '../resalePenaltyStale.mixin';
import '../../../../../assets/style.css';

// Did the resale write-off actually reach the tax records? 200 is a clean run; 206 is
// "adjustments posted, but at least one Tax Roll Summary row was not re-totalled" - the parcel
// changed either way, so the grid has to reload. The action flashes the year/district pairs to
// re-total; anything else means nothing posted and there is nothing to reload.
const adjustmentsPosted = (response) => [200, 206].includes((response || {}).statusCode);

export default {
  mixins: [PaymentCommonFunc, resalePenaltyStaleMixin],
  name: 'DayOfSale',
  components: {
    CRUDList,
    DayOfSaleDialog,
    CommonPaymentDialog,
    ClarionDateControl,
    ResalePenaltyStaleWarning,
  },
  data() {
    return {
      baseCrudKey: 'DayOfSale',
      dialogHeaderName: 'Day of Sale',
      headers: dayOfSaleMainHeader,
      gridLoading: defaultGridLoading(),
      isItFirstCallOrNot: false,
      baseCrudKeyForBidderRegistration: 'BidderRegistrationBaseCrudKey',
      paymentCrudKey: 'paymentTransactionList',
      fromCompBaseCrudKey: 'DayOfSaleForPayment',
      penaltyDateValue: null,
      creatingAdjustments: false,
    };
  },
  created() {
    this.onCreated();
  },
  mounted() {
    if (this.latestSaleYear) {
      this.isItFirstCallOrNot = true;
      this.handleLoadList();
    }
  },
  watch: {
    latestSaleYear(newVal, oldVal) {
      if (newVal && !oldVal) this.criteriaState.saleYear = this.latestSaleYear;
      if (newVal !== 0) {
        this.isItFirstCallOrNot = true;
        this.handleLoadList();
      }
    },
  },
  computed: {
    ...mapGetters('base/crud', ['items', 'item', 'criteria']),
    ...mapState({
      saleYearList: (state) => state.tax.juneResale.saleYearList,
      latestSaleYear: (state) => state.tax.juneResale.latestSaleYear,
      isVisibleBidderRegistration: (state) => state.base.crud.isVisible.BidderRegistration || false,
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem || {},
      resaleSettingItem: (state) => state.SystemConfig.resaleSettingItem || {},
      paymentSettingItem: (state) => state.SystemConfig.paymentSettingItem,
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    defaultSortBy() {
      return [
        {
          column: 'systemId',
          direction: 'asc',
        },
      ];
    },
  },
  methods: {
    manageGridLoading,
    ...mapMutations('base/crud', ['setIsVisible', 'setItem', 'setItems', 'setHighlightedId', 'setCriteria']),
    ...mapActions('tax/juneResale', [
      'loadJuneResale',
      'deleteJuneResale',
      'juneResaleAddFees',
      'juneResaleRecalculatePenalty',
      'bidderRegistration',
      'upsertJuneResaleSelectedFields',
      'juneResaleCreateAdjustments',
      'juneResaleCreateAdjustmentsForWinningBid',
    ]),
    ...mapActions('tax/taxInquires', [
      'loadTaxInquires',
    ]),
    ...mapActions('SystemConfig', [
      'updateConfig',
    ]),
    ...mapActions(['custumColrFlashMsg']),
    async handleLoadList(retaiItemId) {
      if (this.isItFirstCallOrNot) {
        // the resale setting item carries both the penalty date this screen seeds below and the
        // saved date the "Penalty outdated" warning is judged against, so re-read it on every
        // load - that is what clears the warning after a recalculation on either resale screen
        await this.refreshResalePenaltyStaleCheck();
        this.selectedRowData = {};
        manageGridLoading(this, true, 'Searching...');
        const { baseCrudKey } = this;
        const criteria = {
          ...this.criteriaState,
          resaleSortByParcelComponents: this.resaleSettingItem.resaleSortByParcelComponents || false,
        };
        this.loadJuneResale({
          criteria, baseCrudKey, postProcessTrans: this.postProcessForResaleList,
        }).then((res) => {
          this.setDefaultSelectedItems();
          if (retaiItemId) {
            const filterItem = (res || []).filter((ft) => ft._id === retaiItemId);
            if (filterItem.length) {
              this.setItem([baseCrudKey, filterItem[0]]);
            }
            // this is needed to set the default selected items in the day of sale dialog
            setTimeout(() => {
              this.$refs.dayOfSaleDialog.calculateDynamicPriority();
            }, 1000);
          } else {
            this.setItem([baseCrudKey, {}]);
          }
        }).finally(() => {
          manageGridLoading(this, false);
        });
        // set the penalty date value from the resale setting item
        this.penaltyDateValue = this.resaleSettingItem.resalePenaltyDate || this.penaltyDateValue;
      }
    },
    setDefaultSelectedItems() {
      this.$nextTick(() => {
        this.setHighlightedId([this.baseCrudKey, '']);
      });
    },
    postProcessForResaleList(items) {
      const formatPidPositions = this.taxSettingItem.pidValue || '';
      const alteredItems = juneResaleCommonPostProcessTrans(items, formatPidPositions);
      return alteredItems;
    },
    deleteFromDiaglog(deleteItem) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        const { baseCrudKey } = this;
        const item = {
          _id: deleteItem._id,
          systemId: deleteItem.systemId,
        };
        this.deleteJuneResale({ item, baseCrudKey });
      }
    },
    onCreated() {
      const criteria = {
        sortBy: [{ column: 'regNumber', direction: 'asc' }],
      };
      this.bidderRegistration({
        criteria, baseCrudKey: this.baseCrudKeyForBidderRegistration,
      });
    },
    handleRecalculate() {
      const { saleYear } = this.criteriaState;
      if (this.penaltyDateValue && saleYear) {
        const itemToSent = {
          saleYear,
          penaltyDate: toIsoDate(this.penaltyDateValue),
        };
        this.juneResaleRecalculatePenalty({ itemToSent }).then(async () => {
          const item = resaleConfigScope.mergeForPersist(this.resaleSettingItem, {
            resalePenaltyDate: this.penaltyDateValue,
          });
          await this.updateConfig({ calledScope: 'resaleConfig', item });
          this.handleLoadList();
        });
      } else if (!this.penaltyDateValue) this.custumColrFlashMsg({ msg: 'Please select penalty date' });
    },
    calcExcessResale(item) {
      const { winningBid, mainTotalDue } = item;

      const winningBidToNumber = amountToNumber(winningBid);
      const mainTotalDueToNumber = amountToNumber(mainTotalDue);

      let excessResale = winningBidToNumber - mainTotalDueToNumber;
      if (excessResale < 0) {
        excessResale = 0;
      }
      return excessResale || 0;
    },
    upsertItem(item, retainId = false) {
      const itemToSent = {
        regNumber: Number(item.regNumber) || null,
        bidderName: item.bidderName || '',
        countyOwned: item.countyOwned || false,
        cityOwned: item.cityOwned || false,
        excessResale: this.calcExcessResale(item) || 0,
        winningBid: amountToNumber(item.winningBid) || 0,
        _id: item._id,
      };

      this.upsertJuneResaleSelectedFields({ itemToSent }).then(() => {
        if (retainId) this.handleLoadList(item._id);
        else this.handleLoadList();
      });
    },
    async createPayment(item) {
      const _ids = item.taxDetails.map((taxDetail) => taxDetail.taxInquiryTransaction) || [];
      const taxInquiryData = await this.loadTaxInquires({
        criteria: { _ids },
      });
      const alteredTaxInquiryData = [];

      let oldTaxYear = item.mainTaxYear;
      taxInquiryData.forEach((taxDetail) => {
        const taxDetailItem = { ...taxDetail };
        const filteredItem = (item.taxDetails || []).filter((ft) => ft.taxInquiryTransaction === taxDetail._id);
        if (filteredItem.length) {
          taxDetailItem.penaltyAmt = filteredItem[0].currentPenalty;
        }
        alteredTaxInquiryData.push(taxDetailItem);
        // to get the oldest year
        if (taxDetailItem.taxYear < oldTaxYear) oldTaxYear = taxDetailItem.taxYear;
      });
      const criteria = {
        penaltyDateValue: this.resaleSettingItem.resalePenaltyDate,
        paidBy: item.bidderName || '',
        amount: amountToNumber(item.winningBid) || 0,
        resaleFeeAmount: amountToNumber(item.excessResale) || 0,
        oldTaxYear,
      };
      this.setCriteria([this.fromCompBaseCrudKey, criteria]);
      this.setItems([this.fromCompBaseCrudKey, alteredTaxInquiryData]);
      this.$refs.commonPayment.handlePaymentDialog();
    },
    upsertFuncCall(upsertedItem) {
      const item = this.item(this.baseCrudKey);
      const itemToSent = {
        isPaymentCreated: true,
        regNumber: Number(item.regNumber) || null,
        bidderName: item.bidderName || '',
        countyOwned: item.countyOwned || false,
        cityOwned: item.cityOwned || false,
        excessResale: amountToNumber(item.excessResale) || 0,
        paymentNumber: upsertedItem.paymentNumber || 0,
        winningBid: amountToNumber(item.winningBid) || 0,
        _id: item._id,
      };

      this.upsertJuneResaleSelectedFields({ itemToSent })
        .then((response) => {
          if (response.statusCode === 200) {
            this.handleLoadList(item._id);
          }
        });
    },
    searchByCriteria() {
      const returnCriteria = makeCriteriaStateNullIfEmptyString(this.criteriaState);
      this.criteriaState = { ...returnCriteria };
      this.handleLoadList();
    },
    async createAdjustments(item) {
      this.creatingAdjustments = true;
      try {
        // there will be 3 kinds of adjustments, we create wither one of them
        // 1. county owned
        // 2. city owned
        if (item.countyOwned || item.cityOwned) {
          const itemToSent = {
            _id: item._id,
            countyOwned: item.countyOwned || false,
            cityOwned: item.cityOwned || false,
          };
          const response = await this.juneResaleCreateAdjustments({ itemToSent });
          // 206 means the adjustments posted and only the Tax Roll Summary re-total came up
          // short, so the row on this screen HAS changed and still needs reloading. The flash
          // from the action is what tells the operator which year/district to re-total.
          if (adjustmentsPosted(response)) {
            await this.handleLoadList(item._id);
          }
          return;
        }
        // 3. winning bid is less than main total due
        if (amountToNumber(item.mainTotalDue) > amountToNumber(item.winningBid)) {
          const { resaleTaxes, resaleSA } = this.resaleSettingItem;
          const adjustmentAmount = amountToNumber(item.mainTotalDue)
          - amountToNumber(item.winningBid);
          // check is resaleTaxes and resaleSA are same and is resaleSA is less than resaleTaxes
          const resaleTaxesToNumber = amountToNumber(resaleTaxes) || 0;
          const resaleSAToNumber = amountToNumber(resaleSA) || 0;
          const isResaleTaxesAndResaleSAEqual = (resaleTaxesToNumber === resaleSAToNumber)
          || (resaleSAToNumber < resaleTaxesToNumber);
          const itemToSent = {
            _id: item._id,
            adjustmentAmount: amountToNumber(amountFormat(adjustmentAmount)),
            isResaleTaxesAndResaleSAEqual,
            winningBid: amountToNumber(item.winningBid) || 0,
          };
          const response = await this.juneResaleCreateAdjustmentsForWinningBid({ itemToSent });
          if (adjustmentsPosted(response)) {
            await this.handleLoadList(item._id);
          }
        }
      } finally {
        this.creatingAdjustments = false;
      }
    },
  },
};
</script>
